import {createCommonAsyncThunk} from "../../../utils/asyncThunk";
import {GetNewTemplateByIdQuery, GetNewTemplateByIdQueryVariables} from "../../../GQLTypes";
import {getNewTemplateById} from "../../../../newDomain/components/documentsRefactor/api/query";

export const GetPreviewTemplateByIdAction =
    createCommonAsyncThunk<GetNewTemplateByIdQueryVariables, GetNewTemplateByIdQuery["getNewTemplateById"]>(
        'Documents', 'getNewTemplateById', true, false, getNewTemplateById
    );